// extracted by mini-css-extract-plugin
module.exports = {"profile-menu":"profileMenu_profile-menu__29TcZ","profile-menu__avatar":"profileMenu_profile-menu__avatar__2kDxS","profile-menu__header":"profileMenu_profile-menu__header__yJ1KN"};